module.exports = __webpack_public_path__ + "28b67065/img/revit-icon.5ff0d581.svg";